import mixpanel from "mixpanel-browser";

/**
 * Événements Mixpanel communs aux diagnostics Lecture et Mathématiques.
 *
 * Centralisés ici pour que les deux pages d'exercice envoient exactement
 * les mêmes noms d'événements et de propriétés : avant cette extraction,
 * seuls "Clic Commencer Diagnostic" et "Lancement Diagnostic" existaient,
 * donc rien n'indiquait si un parent avançait dans les questions ni s'il
 * terminait réellement le diagnostic.
 */

/**
 * Une question vient d'être validée (qu'elle soit réussie ou non).
 */
export function trackDiagnosticProgress({
  matiere,
  eleveId,
  diagnosticId,
  niveau,
  typeExercice,
  question,
  totalQuestions,
  note,
  bareme,
  derniereQuestionDuNiveau,
}) {
  mixpanel.track("Progression Diagnostic", {
    Matière: matiere,
    "Enfant ID": eleveId,
    "Diagnostic ID": diagnosticId,
    Niveau: niveau,
    "Type Exercice": typeExercice,
    Question: question,
    "Total Questions": totalQuestions,
    Note: note,
    Barème: bareme,
    "Dernière Question Du Niveau": Boolean(derniereQuestionDuNiveau),
  });
}

/**
 * Le parent passe au niveau suivant du diagnostic (pas encore la fin).
 */
export function trackDiagnosticNiveauSuivant({
  matiere,
  eleveId,
  diagnosticId,
  niveauSuivant,
}) {
  mixpanel.track("Niveau Suivant Diagnostic", {
    Matière: matiere,
    "Enfant ID": eleveId,
    "Diagnostic ID": diagnosticId,
    "Niveau Suivant": niveauSuivant,
  });
}

/**
 * Le diagnostic est enregistré côté backend : c'est la vraie complétion,
 * à distinguer du simple clic "Commencer" qui n'engageait à rien.
 */
export function trackDiagnosticCompleted({
  matiere,
  eleveId,
  diagnosticId,
  tentativeId,
  statut,
  scoreTotal,
  nombreNiveaux,
  creditsRestants,
}) {
  mixpanel.track("Diagnostic Terminé", {
    Matière: matiere,
    "Enfant ID": eleveId,
    "Diagnostic ID": diagnosticId,
    "Tentative ID": tentativeId,
    Statut: statut,
    "Score Total": scoreTotal,
    "Nombre Niveaux": nombreNiveaux,
    "Crédits Restants": creditsRestants,
  });
}
